import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import PlaceAutocomplete from "../../components/Business/Map/PlaceAutocomplete.jsx";
import SuccessModal from "../../components/SuccessModal/SuccessModal.jsx";



const YourBusiness = () => {
  const [business, setBusiness] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState({});

  const [successModalOpen, setSucessModalOpen] = useState(false)

  const fetchBusiness = async () => {
    try {
      const response = await api.get("/business-owner/business");
      const businessDetails = response.data.business
      setBusiness(businessDetails);
      setSelectedLocation(businessDetails.location)
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBusiness();
  }, []);

  const handleMapClick = (event) => {
    const lat = event.detail.latLng.lat;
    const lng = event.detail.latLng.lng;
    setSelectedLocation({ lat, lng });
    console.log("Selected Location:", { lat, lng });
  };

  

  const handlePlaceSelect = (location, address) => {
    setSelectedLocation(location);
    setBusiness((prev) => ({...prev, address: address}))
  };

  const handleSave = async () => {
    try {
      const response = await api.patch("/business-owner/business", {
        name: business.name,
        address: business.address,
        location: {
          lat: selectedLocation.lat,
          lng: selectedLocation.lng
        }
      })

      setBusiness(response.data.business)
      setSucessModalOpen(true)
    } catch (error) {
      console.log(error)
    }
  }

  if (loading) {
    return (
      <div>
        <div className="text-center">
          <div role="status">
            <svg
              aria-hidden="true"
              className="inline w-10 h-10 text-gray-200 animate-spin fill-indigo-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <h1 className="text-base font-semibold text-gray-900">Your Business</h1>
      <div className="flex justify-between mt-10 gap-10 flex-col md:flex-row">
        <div className="flex-1">
          <div >
            <label
              htmlFor="businessCode"
              className="block text-sm/6 font-medium text-gray-900"
            >
              Business Code
            </label>
            <div className="mt-2">
              <input
                id="businessCode"
                name="businessCode"
                type="text"
                disabled
                defaultValue={business.code}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200 sm:text-sm/6"
              />
            </div>
          </div>
          <div className="mt-3">
            <label
              htmlFor="businessName"
              className="block text-sm/6 font-medium text-gray-900"
            >
              Business Name
            </label>
            <div className="mt-2">
              <input
                id="businessName"
                name="businessName"
                type="text"
                defaultValue={business.name}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>
          
        </div>
        <div className="flex-1">
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY} libraries={["places"]}>
            <PlaceAutocomplete onPlaceSelect={handlePlaceSelect} address={business.address}/>
              <div className="mt-3 w-full h-[600px] rounded-lg overflow-hidden shadow-lg">
                <Map
                  mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
                  defaultCenter={selectedLocation}
                  defaultZoom={17}
                  gestureHandling={'greedy'}
                  onClick={handleMapClick}
                  disableDefaultUI={true}
                >
                  {selectedLocation && (
                    <AdvancedMarker position={{ lat: selectedLocation.lat, lng: selectedLocation.lng }} />
                  )}
                </Map>
              </div>
          </APIProvider>
        </div>
      </div>

      <div className="mt-4">
        <button
          type="submit"
          onClick={handleSave}
          className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Save
        </button>
      </div>

      <SuccessModal successModalOpen={successModalOpen} setSuccessModalOpen={setSucessModalOpen} />
    </div>
  );
};

export default YourBusiness;